import styled from 'styled-components'

export const StyledNewsNavigation = styled.div`
  padding: 15px 0;

  .newsNavigation {
    align-items: center;
  }
`
